import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import api from "./api"; // Your Axios instance

function LeadSetPassword() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { token } = useParams(); // Token from URL
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [csrfToken, setCsrfToken] = useState("");
  const [loading, setLoading] = useState(false);

  
  // Fetch CSRF token
  useEffect(() => {
    api.get(`${baseUrl}/get-csrf-token/`, { withCredentials: true })
      .then(response => setCsrfToken(response.data.csrfToken))
      .catch();
  }, [baseUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 7) {
      setError("Password must be at least 7 characters long");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);

    try {
      const response = await api.post(
        `${baseUrl}/lead/set-password/${token}/`,
        { password },
        {
          withCredentials: true,
          headers: { "X-CSRFToken": csrfToken }
        }
      );

      if (response.data.success) {
        setMessage("Password set successfully! Redirecting to login page");
        setError("");
        setTimeout(() => navigate("/seller/login"), 2000);
        setLoading(false);
      } else {
        setError(response.data.message || "Unable to set password");        
        setLoading(false);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  return (
    <section className="container mtopcon normal-mt-sctn">
      <div className="row">
        <div className="col-12 col-lg-4 reglogincon">
          <div className="card shadow-none">
            <h2 className='text-center'><b>Welcome to Kadhr</b></h2>
            
            <div className="card-body mt-0 pt-0">
              {error && <p className="text-danger text-center">{error}</p>}
              {message && <p className="text-success text-center">{message}</p>}
              <div className="mb-3 font9 text-center">
                <p>Set a password to start selling.</p>
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="col-12 btn btn-dark"
                onClick={handleSubmit}
              >
                { loading === true ? <>Loading...</> : <>Save Password</>}
              </button>
              <div className="mb-2 mt-4 font9">
                <p>Need help? <Link to="/help-center">Contact support</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LeadSetPassword;
